import { FC } from 'react';
import { AmplienceMegaNavProps } from '../header-nav/components/mega-nav';
import AmplienceNavColumn from '../header-nav/components/nav-column';
import AmplienceNavColumnMobile from '../header-nav/components/nav-column/nav-column-mobile';
import AmplienceMegaNavMobile from '../header-nav/components/mega-nav/mega-nav-mobile';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop } from 'helpers/utils/screensizes';

export interface FooterMegaNavProps {
  megaNav: AmplienceMegaNavProps;
}
const FooterMegaNav: FC<FooterMegaNavProps> = ({ megaNav }) => {
  const [isDesktop] = useMediaQuery(desktop);
  return (
    megaNav &&
    megaNav.navColumns?.length > 0 &&
    (isDesktop ? (
      <div
        className="mb-12 mt-9 h-auto w-full px-[15px] lg:mx-auto lg:max-w-[var(--page-max-width)] lg:px-4"
        data-testid="footer-desktop-navigation"
      >
        <section className="mx-auto grid max-w-desktop">
          <section className="flex justify-between">
            {megaNav?.navColumns.map((navColumn) => (
              <AmplienceNavColumn key={`nav-column-${navColumn?.mainTitle}`} {...navColumn} isFooterColumn={true} />
            ))}
          </section>
        </section>
      </div>
    ) : (
      <div data-testid="footer-mobile-navigation">
        <AmplienceMegaNavMobile
          title={megaNav.title}
          link={megaNav.link}
          navColumns={megaNav.navColumns}
          includeHeader={false}
          navColumnClassName="!border-0"
        />
      </div>
    ))
  );
};

export default FooterMegaNav;
